export default "__VITE_ASSET__CuYLngfo__"